"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./style.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CustomTabs = function CustomTabs(_ref) {
  var intl = _ref.intl,
      title = _ref.title,
      tabSlugs = _ref.tabs,
      tabObjects = _ref.tabObjects,
      activeTab = _ref.activeTab,
      setActiveTab = _ref.setActiveTab,
      _ref$namePrefix = _ref.namePrefix,
      namePrefix = _ref$namePrefix === void 0 ? 'datamanagement' : _ref$namePrefix;
  var t = intl.messages;
  var tabs = (0, _react.useMemo)(function () {
    return tabObjects || (tabSlugs || []).map(function (slug) {
      return {
        slug: slug,
        name: t["".concat(namePrefix, "_").concat(slug)]
      };
    });
  }, [namePrefix, t, tabObjects, tabSlugs]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomTabs"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "CustomTabs-title"
  }, title), tabs.length < 1 ? null : /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomTabs-tabs"
  }, tabs.map(function (_ref2) {
    var slug = _ref2.slug,
        name = _ref2.name;
    return /*#__PURE__*/_react.default.createElement("span", {
      key: slug,
      className: "CustomTabs-tab ".concat(slug !== activeTab ? null : 'CustomTab-tab-active'),
      onClick: function onClick() {
        return setActiveTab(slug);
      }
    }, name);
  }))));
};

var _default = CustomTabs;
exports.default = _default;